import { HttpClient } from '@angular/common/http';
import { inject, Injectable, signal } from '@angular/core';
import {
  httpGetCustomerUserAvailableMandantsByCustomer,
  SessionContextResponseDto,
  UserAvailableMandantsByCustomersCustomerDto,
} from '@zvoove-market/api';
import { backendUrl } from '@zvoove-market/shared';
import { from } from 'rxjs';
import { map, tap } from 'rxjs/operators';
import { getInitialLoginContext, loadLoginContext } from '../bootstrap/bootstrap';

export const deps = {
  getInitialLoginContext: getInitialLoginContext,
  loadLoginContext: loadLoginContext,
};

function getEmptySessionContext(): SessionContextResponseDto {
  return {
    isLoggedIn: false,
    firstName: '',
    globalRoles: [],
    isTemporaryAccess: false,
    language: '',
    lastName: '',
    userId: null,
    userName: '',
    deploymentEnvironment: '',
    isSsoVerify: false,
    version: null,
    hasCustomers: false,
    customer: null,
    mandant: null,
  };
}

@Injectable({ providedIn: 'root' })
export class AuthService {
  private http = inject(HttpClient);

  public readonly $context = signal<SessionContextResponseDto>(deps.getInitialLoginContext() ?? getEmptySessionContext());
  public readonly $availableMandantsByCustomers = signal<UserAvailableMandantsByCustomersCustomerDto[] | null>(null);

  public refreshLoginContext(mandantId?: string) {
    return from(deps.loadLoginContext(backendUrl(), mandantId)).pipe(
      tap((loginContext) => {
        this.$context.set(loginContext);
      })
    );
  }

  public refreshAvailableMandantsByCustomers() {
    return httpGetCustomerUserAvailableMandantsByCustomer(this.http).pipe(
      map((response) => {
        this.$availableMandantsByCustomers.set(response.customers);
        return response.customers;
      })
    );
  }
}
